import { useTranslations } from 'next-intl';
import { BaseLineFeedback } from '@/app/components/icons/BaseLineFeedback';
import { BaseLineShare } from '@/app/components/icons/BaseLineShare';
import { EllipsisDropdownMenu } from '@/app/components/shared/EllipsisDropdownMenu';
import { PostStatusTag } from '@/app/components/shared/PostStatusTag';
import { Button } from '@/app/components/ui/button';
import { SITE } from '@/app/constants';
import { EllipsisActionTypeEnum } from '@/app/types';
import { cn } from '@/app/utils';
import type { ElementDetail } from '../types';

/**
 * TitleSection 组件支持的 mode 类型
 * 只支持 view 和 post 模式，edit 和 create 模式使用 ElementDialog 组件
 */
export type TitleSectionMode = 'view' | 'post' | null;

interface TitleSectionProps {
  className?: string;
  mode: TitleSectionMode;
  isAuthor: boolean;
  shareStatus?: ElementDetail['shareStatus'];
  onReport: () => void;
  handleShareClick: () => void;
}

export const TitleSection = ({
  className,
  mode,
  isAuthor,
  shareStatus,
  onReport,
  handleShareClick,
}: TitleSectionProps) => {
  const t = useTranslations('elements');

  return (
    <div className={cn('relative flex w-full justify-between gap-2 sm:justify-center', className)}>
      <div className="flex flex-1 items-center overflow-hidden font-medium text-base text-white">
        <div className="truncate font-medium text-sm">
          {mode === 'view' ? t('elementDialog.title.view') : t('submit.dialog.title')}
        </div>
        {mode === 'view' && isAuthor && ['approved', 'pending'].includes(shareStatus || '') && (
          <PostStatusTag
            className="ml-1 flex-shrink-0"
            tag={{
              status: shareStatus,
            }}
          />
        )}
      </div>
      <div className="flex items-center gap-3">
        {mode === 'view' && shareStatus === 'approved' && (
          <Button
            variant="text"
            className="skip-login-check aspect-square h-full bg-transparent text-lg"
            size="original"
            onClick={handleShareClick}
          >
            <BaseLineShare />
          </Button>
        )}

        {mode === 'view' && !isAuthor && SITE === 'china' && (
          <EllipsisDropdownMenu
            className="aspect-square h-full bg-transparent text-lg"
            actions={[{ action: EllipsisActionTypeEnum.InspirationReport, icon: <BaseLineFeedback /> }]}
            onSelectedAction={(action: EllipsisActionTypeEnum) => {
              if (action === EllipsisActionTypeEnum.InspirationReport) {
                onReport();
              }
            }}
          />
        )}
      </div>
    </div>
  );
};
